import { render } from "./AboutChatRDG.vue?vue&type=template&id=8f391628"
import script from "./AboutChatRDG.vue?vue&type=script&lang=js"
export * from "./AboutChatRDG.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__